import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatDataGrid = createCustomElementWrapper('kat-data-grid', 'KatDataGrid', {
    'actionColMinWidth': 'action-col-min-width',
    'additionalFilter': 'additional-filter',
    'allFilter': 'all-filter',
    'alwaysAutoSizeColumns': 'always-auto-size-columns',
    'autoFilterRowCount': 'auto-filter-row-count',
    'autoHeight': 'auto-height',
    'bulkEdit': 'bulk-edit',
    'clientSideData': 'client-side-data',
    'detailRowHeight': 'detail-row-height',
    'indefiniteResultsSize': 'indefinite-results-size',
    'isLoading': 'is-loading',
    'licenseKey': 'license-key',
    'loadingText': 'loading-text',
    'masterDetail': 'master-detail',
    'noFilteredResultsMessage': 'no-filtered-results-message',
    'noResultsMessage': 'no-results-message',
    'pageSize': 'page-size',
    'paginationPrefix': 'pagination-prefix',
    'primaryKeyField': 'primary-key-field',
    'resultsPerPageOptions': 'results-per-page-options',
    'rowData': 'row-data',
    'rowEdit': 'row-edit',
    'searchOptions': 'search-options',
    'searchPlaceholder': 'search-placeholder',
    'searchTerm': 'search-term',
    'showSearchDropDown': 'show-search-drop-down',
    'totalRowCount': 'total-row-count',
    'totalRowCountAfterFilter': 'total-row-count-after-filter',
}, {
    'onCustomFilterChanged': 'customFilterChanged',
    'onFiltersCleared': 'filtersCleared',
    'onGridReady': 'gridReady',
    'onRowsEdited': 'rowsEdited',
    'onSelectionChanged': 'selectionChanged',
}, [
    'filter',
    'selection-actionbar',
    'custom-controls',
]);
